import React from "react";
import s from "./style.module.css";
import cn from "classnames";

const CTABox = ({ heading, text, url, cta, img }) => {
  const style = process.env.REACT_APP_STYLE || "ss";

  return (
    <div>
      <div
        className={cn(s.cta, {
          [s.ss]: style === "ss",
          [s.tj]: style === "tj",
        })}
      >
        <div>
          <img className={s.img} src={img} alt="" />
        </div>

        <div>
          <p className={s.heading}>{heading}</p>
          <p className={s.text}>{text}</p>

          <p className={s.text}>
            <a className={s.button} href={url} target="_blank" rel="noreferrer">
              {cta}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CTABox;
